import { TcktDesc } from "../../../services/ticket/get-infra-task-ticket/GetInfraTaskResponse";

export type InfraTicketDescriptionDialogState = {
  isShow: boolean;
  tcktDesc?: TcktDesc;
};
export type PageNewState =
  | InfraTicketDescriptionDialogState
  | ((
      prevState: InfraTicketDescriptionDialogState,
    ) => InfraTicketDescriptionDialogState);
